module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-get-started@3x.7d1d57f2.png";